import { useContext } from "react";
import Context from "../../../context";
import ContactPage from "../ContactPage/ContactPage";
import AccountDetailPage from "./AccountDetailPage";
import ManageAccountAddAccountPage from "./ManageAccount/ManageAccountAddAccountPage";
import RenewPlanPage from "./RenewPlanPage";

export default function AccountDetail() {
  const { contextState, setContextState } = useContext(Context);
  return (
    <>
      {contextState.detailActivePage === "overview" && <AccountDetailPage />}
      {contextState.detailActivePage === "renew" && <RenewPlanPage />}
      {contextState.detailActivePage === "contact" && <ContactPage />}
      {contextState.detailActivePage === "add" && (
        <ManageAccountAddAccountPage shouldScroll />
      )}
    </>
  );
}
